import styled from '@emotion/styled'

import { Maybe } from '@bemlo/utils'

import { RangeUIButton, RangeUIWrapper } from './Elements'
import { Color, theme } from '../../constants'
import { useTranslations } from '../../translate'
import { Div } from '../Div'
import { DatePicker } from '../Form/DatePicker'
import { Icon } from '../Icon'

const Label = styled.span({
  fontWeight: theme.font.weight.book,
  paddingRight: theme.spacing[1],
  color: Color.DARKEST_MEDIUM_GREY,
})

type CustomRangeProps = {
  startLabel: string
  endLabel: string | undefined
  startDate: Date
  endDate: Maybe<Date>
  onChange: (values: { startDate?: Date | null; endDate?: Date | null }) => void
}

export const CustomRange = (props: CustomRangeProps) => {
  const t = useTranslations()

  return (
    <RangeUIWrapper>
      <DatePicker
        maxDate={props.endDate}
        value={props.startDate}
        onChange={(startDate) => props.onChange({ startDate })}
        input={
          <RangeUIButton size="xs" design="white" styles={{ pr: 3, pl: 2.5 }}>
            <Label>{t.form.from()}:</Label> {props.startLabel}
          </RangeUIButton>
        }
      />
      <Div styles={{ position: 'relative' }}>
        <Icon
          backgroundColor={Color.WHITE}
          name="ArrowRightIcon"
          color={Color.DARK_MEDIUM_GREY}
          size="sm"
          styles={{
            zIndex: 1,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </Div>
      <DatePicker
        minDate={props.startDate}
        value={props.endDate}
        onChange={(endDate) => props.onChange({ endDate })}
        input={
          <RangeUIButton
            size="xs"
            design="white"
            styles={{
              color: props.endDate ? undefined : Color.DARK_GREY,
              pl: 3,
              pr: 2.5,
            }}
          >
            <Label>{t.form.to()}:</Label>{' '}
            {props.endLabel ?? `${t.form.select_a_date()}...`}
          </RangeUIButton>
        }
      />
    </RangeUIWrapper>
  )
}
